<div class="container">
  <div [matMenuTriggerFor]="menu" class="profile">
    @if (employee$()) {
      <div class="profile-info-content">
        <span class="profile-info-display-name">
          {{ employeeDisplayName$() }}
        </span>

        <img
          class="profile-info-image"
          src="{{ employeeAvatarPath$() }}"
          alt="Profilbild"
          i18n-alt
        />
      </div>
    }
  </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item routerLink="/profile">
    <mat-icon>settings</mat-icon>
    <span class="ns" i18n>Einstellungen</span>
  </button>
  <button
    mat-menu-item
    onclick="window.open('https://blankmile.com/kontakt/', '_blank');"
    type="button"
  >
    <mat-icon>help_outline</mat-icon>
    <span i18n>Hilfe</span>
  </button>
  <mat-divider></mat-divider>
  <button (click)="onLogout()" mat-menu-item>
    <mat-icon>logout</mat-icon>
    <span i18n>Ausloggen</span>
  </button>
</mat-menu>
